import { AddressType } from './address-type';

export class Address {
    id?: number;
    addressType: AddressType;
    address1?: string;
    address2?: string;
    city?: string;
    countryISO3?: string;
    postalCode?: string;
    stateAbbreviation?: string;
}
